import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent {
  showLoader = false;

  private readonly destroyRef = inject(DestroyRef);

  constructor(private readonly loaderService: LoaderService) {
    this.loaderService
      .getLoader()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state) => {
        this.showLoader = state;
      });
  }
}
